import { useSelector } from 'react-redux'
import { selectTheme } from '../../../app/slice'

export const UseTheme = () => {
  const theme = useSelector(selectTheme)

  return theme
}
